import { api } from '@services';

import Resource, { IResource, IResourceApiModel } from '@models/Resource.model';

interface INewResource {
  resourceId: string;
  label?: string;
  uri?: string;
  description?: string;
  productIds?: string[];
  manufacturerId?: string;
  haveOwnerStudio?: boolean;
  isGlobal?: boolean;
  favorite?: boolean;
}
interface IManufacturerVariables {
  data: INewResource;
}

const changeResource = async ({
  data: { resourceId, ...data },
}: IManufacturerVariables): Promise<IResource> => {
  const { data: resource } = await api.patch<IResourceApiModel>(
    `/resources/${resourceId}`,
    data,
  );

  return Resource.fromApiModel(resource);
};

export { changeResource };
